export function DataGridProgressCell({ value }) {
  const progress = Math.max(0, Math.min(value ?? 0, 1));

  if (progress === 0) {
    return (
      <span className="inline-flex items-center rounded-full border border-slate-300 bg-slate-100 px-2.5 py-1 text-xs font-medium text-ccColorTeal">
        Setting up
      </span>
    );
  }

  if (progress === 1) {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-medium text-emerald-700">
        <svg
          viewBox="0 0 20 20"
          fill="currentColor"
          className="h-3.5 w-3.5"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M16.704 5.293a1 1 0 0 1 .003 1.414l-8 8a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L8 12.586l7.293-7.293a1 1 0 0 1 1.411 0Z"
            clipRule="evenodd"
          />
        </svg>

        ready
      </span>
    );
  }

  const percentage = Math.round(progress * 100);

  return (<div className="relative h-5 w-full overflow-hidden rounded-full bg-slate-200" role="progressbar" aria-valuenow={percentage} aria-valuemin={0} aria-valuemax={100} >
     {/* Progress */} 
     <div className="h-full rounded-full bg-ccColorLightTeal transition-[width] duration-300" style={{ width: `${percentage}%` }} />
     {/* Percentage */} 
     <span className="absolute inset-0 flex items-center justify-center text-xs font-semibold text-ccColorDarkTeal"> {percentage}% </span>
     </div> );
}